import { Plane, shaderMaterial } from '@react-three/drei'
import { extend, useFrame } from '@react-three/fiber'
import * as THREE from 'three'
import { fragmentShader } from '../shaders/background/fragment'
import { vertexShader } from '../shaders/background/vertex'
import { useEffect, useState, useRef } from 'react'
import { useScreenSize } from '../hooks/useScreenSize'
import { a, useSpring, easings } from '@react-spring/three'
import { useDeviceOrientation } from '../hooks/useDeviceOrientation'
import { easing } from 'maath'

const WaveShaderMaterial = shaderMaterial(
    // Uniform
    {
        uTime: 0,
        uColor1: new THREE.Color('#606c38'),
        uColor2: new THREE.Color('#bc6c25'),
        uColorAccent: new THREE.Color('#000000'),
        uLinesBlur: 0.4,
        uNoise: 0.035,
        uOffsetX: 0.54,
        uOffsetY: 0.02,
        uLinesAmount: 5,
        uPlaneRes: [60, 60], //Plane size in pixel,
        uMouse2D: [0, 0], //Mouse coords from [0,0] (top left corner) to [screenWidth , screenHeight]
        uBackgroundScale: 2
    },
    // Vertex Shader
    vertexShader,
    // Fragment Shader
    fragmentShader
)

extend({ WaveShaderMaterial })

export function Background(props) {
    const ref = useRef(null)
    const refMaterial = useRef(null)

    const { screenWidth, screenHeight } = useScreenSize()
    const { orientation, error, requestAccess, revokeAccess } = useDeviceOrientation()
    const [orientationMouse2D, setOrientationMouse2D] = useState([0, 0])

    const backgroundScale = screenWidth <= 640 ? 7 : 4

    const FinalMaterial = a(({ ...props }) => {
        return (
            <waveShaderMaterial
                uLinesBlur={props.uLinesBlur}
                uLinesAmount={props.uLinesAmount}
                uBackgroundScale={backgroundScale}
                uOffsetX={props.uOffsetX}
                uOffsetY={0}
            />
        )
    })

    useEffect(() => {
        requestAccess()
        // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
        {
            if (!orientation) return
            setOrientationMouse2D([orientation.beta / 180, orientation.gamma / 45])
        }
    }, [orientation])

    useFrame((state, delta) => {
        const viewport = state.viewport.getCurrentViewport(state.camera, [0, 0, 15])

        if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            easing.damp2(
                ref.current.material.uniforms.uMouse2D.value,
                [(props.mouse2D.x * viewport.width * 1.2) / 2, (props.mouse2D.y * viewport.height) / 2],
                0.8,
                delta
            )
        } else {
            easing.damp2(ref.current.material.uniforms.uMouse2D.value, orientationMouse2D, 0.8, delta)
        }
    })

    return (
        <>
            <Plane
                args={[50, 20]}
                position={[0, 0, -50]}
                rotation={[0, 0, 0]}
                ref={ref}
                onClick={() => {
                    requestAccess()
                }}>
                <FinalMaterial uLinesAmount={5} uLinesBlur={0.35} uOffsetX={0.34} ref={refMaterial} />
            </Plane>
        </>
    )
}

// delay in ms
function debounced(delay, fn) {
    let timerId
    return function (...args) {
        if (timerId) {
            clearTimeout(timerId)
        }
        timerId = setTimeout(() => {
            fn(...args)
            timerId = null
        }, delay)
    }
}
